import { render, staticRenderFns } from "./dnimport_no.vue?vue&type=template&id=2d05d4c0&scoped=true&"
import script from "./dnimport_no.vue?vue&type=script&lang=js&"
export * from "./dnimport_no.vue?vue&type=script&lang=js&"
import style0 from "./dnimport_no.vue?vue&type=style&index=0&id=2d05d4c0&lang=scss&scoped=true&"
import style1 from "./dnimport_no.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d05d4c0",
  null
  
)

export default component.exports